const InitContactWidget = () => {
  const contactWidget = document.querySelector<HTMLElement>('.saf-contact-widget');

  document.addEventListener('scroll', () => {
    setTimeout(() => {
      contactWidget?.classList.add('show');
    }, 1000)
  }, { once: true })
}

InitContactWidget()
